<div class="d-inline-block">
    @if (isSugarCrmAndTrackingAvailable) {
        @if (postnordLink) {
            <a [href]="postnordLink" target="_blank" class="btn btn-icon btn-opacity" style="padding: 5px 2px">
                <img src="/assets/images/postnord.png" style="height: 18px; width: 18px" />
            </a>
        }
        @if (trackingLink) {
            <a [href]="trackingLink" target="_blank" class="btn btn-icon btn-opacity" style="padding: 7px 2px">
                <img src="/assets/images/tracking-code.png" />
            </a>
        }
        <a [href]="sugarCrmLink" target="_blank" class="btn btn-icon btn-opacity" style="padding: 6px">
            <img src="/assets/images/sugar-crm.png" />
        </a>
    }
    @if (
        isTicketHeaderVisible('anonymizeAction') &&
        ticket.constraints?.isAnonymizationAllowed &&
        !commonDataService.isOneTime
    ) {
        <button
            class="btn btn-icon"
            data-testid="inbox-ui-ticket-header-anonymize-action"
            [ngClass]="{ 'btn-active': ticket.isAnonymized }"
            [disabled]="
                isAnonymizingThread ||
                ticket.isAnonymized ||
                (isCustomerOnline && ticket.source === ticketSourceEnum.chat)
            "
            (click)="openAnonymizeThreadModal()"
            tooltip="{{ (ticket.isAnonymized ? 'Ticket is anonymized' : 'Anonymize ticket') | translate }}"
            placement="bottom">
            <sb-inline-svg
                class="icon"
                aria-label="My icon"
                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Mask icon.svg'">
            </sb-inline-svg>
        </button>
    }

    @if (isTicketHeaderVisible('spamAction') && !commonDataService.isOneTime) {
        <button
            class="btn btn-icon"
            data-testid="inbox-ui-ticket-header-spam-action"
            [ngClass]="{ 'btn-active': ticket.isSpam }"
            [disabled]="isUpdatingSpam"
            (click)="openMarkAsSpamModal()"
            tooltip="{{
                (ticket.isSpam
                    ? isSocialMediaTicket
                        ? 'Remove this ticket from spam'
                        : 'Remove this email address from spammers'
                    : isSocialMediaTicket
                      ? 'Move this ticket to spam'
                      : 'Add this email address as spammer'
                ) | translate
            }}"
            placement="bottom">
            <sb-inline-svg
                class="icon"
                aria-label="My icon"
                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Prohibited icon.svg'">
            </sb-inline-svg>
        </button>
    }
    @if (ticket.isTicketCanBeReplied) {
        <button
            class="btn btn-icon"
            (click)="showFullReplyForm()"
            tooltip="{{ 'Answer on the ticket' | translate }}"
            placement="bottom">
            <sb-inline-svg
                class="icon icon-flipped"
                aria-label="My icon"
                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Forward icon.svg'">
            </sb-inline-svg>
        </button>
    }

    @if (isTicketHeaderVisible('forwardAction') && !commonDataService.isOneTime) {
        <button
            class="btn btn-icon"
            data-testid="inbox-ui-ticket-header-forward-action"
            (click)="openForwardForm()"
            tooltip="{{ 'Forward the ticket' | translate }}"
            placement="bottom">
            <sb-inline-svg
                class="icon"
                aria-label="My icon"
                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Wide arrow.svg'">
            </sb-inline-svg>
        </button>
    }

    @if (
        isTicketHeaderVisible('redactAction') &&
        !commonDataService.isOneTime &&
        commonDataService.user.constraints.isRedactingAllowed
    ) {
        <button
            class="btn btn-icon"
            data-testid="inbox-ui-ticket-header-redact-action"
            [disabled]="
                commonDataService.customerSettings.isTicketAssigningObligatory &&
                (!ticket.isAssigned || (ticket.isAssigned && ticket.assignee.id !== this.commonDataService.user.id))
            "
            (click)="openRedactForm()"
            tooltip="{{ 'Redact the ticket' | translate }}"
            placement="bottom">
            <sb-inline-svg
                class="icon"
                aria-label="My icon"
                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Eraser-icon.svg'">
            </sb-inline-svg>
        </button>
    }

    @if (!commonDataService.isOneTime && ticket.isEditable && ticket.constraints.isMutingAllowed) {
        <button
            class="btn btn-icon"
            (click)="muteTicket()"
            [disabled]="isMuteStateUpdating"
            [ngClass]="{ 'btn-active': ticket.isMuted }"
            placement="bottom"
            tooltip="{{ (ticket.isMuted ? 'Unmute the ticket' : 'Mute the ticket') | translate }}">
            <sb-inline-svg
                class="icon"
                aria-label="My icon"
                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Muted icon.svg'">
            </sb-inline-svg>
        </button>
    }

    @if (isTicketHeaderVisible('openInNewTabAction') && !commonDataService.isOneTime) {
        <a
            class="btn btn-icon btn-icon"
            data-testid="inbox-ui-ticket-header-open-in-new-tab-action"
            [href]="ticketLink"
            target="_blank"
            tooltip="{{ 'Open ticket in new tab' | translate }}"
            placement="bottom">
            <sb-inline-svg
                class="icon"
                aria-label="My icon"
                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/New tab icon.svg'">
            </sb-inline-svg>
        </a>
    }

    @if (!commonDataService.isOneTime && ticket.constraints?.isSendingTicketToBergHansenAllowed) {
        <div class="d-inline-block" tooltip="{{ 'Pop-up' | translate }}" placement="bottom">
            <button (click)="pingTeammates()" class="btn btn-icon btn-icon" type="button">
                <sb-inline-svg
                    class="icon"
                    style="padding: 0 0 3px 0"
                    aria-label="My icon"
                    [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Hat icon.svg'">
                </sb-inline-svg>
            </button>
        </div>
    }

    @if (isTicketHeaderVisible('remindAction') && !commonDataService.isOneTime) {
        <div dropdown class="d-inline-block position-relative" container="body">
            <button
                dropdownToggle
                class="btn btn-icon btn-icon btn-reminder"
                data-testid="inbox-ui-ticket-header-remind-action"
                type="button"
                tooltip="{{ 'Remind' | translate }}"
                placement="top">
                <sb-inline-svg
                    class="icon"
                    [ngClass]="{ active: ticket.reminder }"
                    style="padding: 2.5px"
                    [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Timer outlined icon.svg'">
                </sb-inline-svg>
            </button>

            <ul
                *dropdownMenu
                class="dropdown-menu dropdown-menu-left"
                role="menu"
                aria-labelledby="button-basic"
                style="min-width: 220px">
                <app-reminder-menu
                    [isReminderAdded]="!!ticket.reminder"
                    [hasReopenOption]="true"
                    [isReopen]="isReopenTicket"
                    [isSaving]="isSavingReminder"
                    (remindClick)="onRemindClick($event)"
                    (isReopenClick)="onIsReopenClick($event)"
                    (removeReminderClick)="deleteReminder()"
                    (pickDateAndTimeClick)="openReminderModal()"></app-reminder-menu>
            </ul>
        </div>
    }

    @if (!commonDataService.isOneTime && isMoreActionsVisible()) {
        <div class="btn-group print-hidden ms-2" dropdown>
            <button id="button-basic" dropdownToggle type="button" class="btn btn-icon" aria-controls="dropdown-basic">
                <sb-inline-svg
                    class="icon"
                    aria-label="My icon"
                    [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/More icon.svg'">
                </sb-inline-svg>
            </button>

            <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
                @if (ticket.isEditable && ticket.constraints.isHidingAllowed) {
                    <li role="menuitem">
                        <app-hide-post-button [ticket]="ticket"></app-hide-post-button>
                    </li>
                }
                @if (ticket.isEditable && ticket.constraints.isDeletionAllowed) {
                    <li role="menuitem">
                        <button class="dropdown-item" type="button" (click)="openDeletePostModal()" translate>
                            Delete post
                        </button>
                    </li>
                }
                @if (isTicketHeaderVisible('printAction')) {
                    <li role="menuitem">
                        <button
                            class="dropdown-item"
                            data-testid="inbox-ui-ticket-header-print-action"
                            type="button"
                            (click)="printTicket()"
                            translate>
                            Print
                        </button>
                    </li>
                }
            </ul>
        </div>
    }
</div>
